<template>
  <v-flex xs12 sm12 md12>

    <v-text-field   hide-details="" :tabindex="tabdeger" v-model="displayValue" :disabled="Boolean(aktif)" :label="etiket"
      :name="name"  @blur="test()" :id="id" @focus="isInputActive=true">
    </v-text-field>

  </v-flex>


</template>

<script>
  export default {
    name: 'currency-input',
    data() {
      return {
        isInputActive: false
      }
    },
    props: ['value', 'tabindex', 'name', 'id', 'etiket', 'aktif', 'tabdeger','simge','rules','isPositive'],
     computed: {
      displayValue: {
        get: function () {
        //  this.value = parseFloat(this.value)
          if (typeof (this.value) != 'number') {
            return 0
          }
          // eslint-disable-next-line no-empty
          if(typeof(this.simge) == 'undefined'){
     
          }
          if (this.isInputActive) {
            return this.value.toString()
          } else {
            var result = this.value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)()/g, '$1,') + this.simge; 
            if(this.isPositive){
                var controlMinus = result.search('-');
                  if(controlMinus == 0){
                    this.$emit('input',0);
                    return 0;
                  }
            }
            
            return result;
          }

        },
        set: function (modifiedValue) {
          let newValue = parseFloat(modifiedValue)
          if (isNaN(newValue)) {
            newValue = 0
          }
          this.$emit('input', parseFloat(newValue))
        }
      },
      
    },
    methods: {
        test(){
    this.isInputActive=false
    this.$emit('odakkaybi', this.value)
    },
      getsifir() {
        return 0;
      }
    }
  }
</script>

<style scoped>
</style>